import { useEffect, useRef, useState } from 'react';
import { useInView } from 'motion/react';
import TESTIMONIAL0_VIDEO from '@/assets/testimonial-video-0.mp4';
import TESTIMONIAL1_VIDEO from '@/assets/testimonial-video-1.mp4';
import TESTIMONIAL2_VIDEO from '@/assets/testimonial-video-2.mp4';
import TESTIMONIAL3_VIDEO from '@/assets/testimonial-video-3.mp4';
import TESTIMONIAL4_VIDEO from '@/assets/testimonial-video-4.mp4';
import TESTIMONIAL5_VIDEO from '@/assets/testimonial-video-5.mp4';
import TESTIMONIAL6_VIDEO from '@/assets/testimonial-video-6.mp4';
import TESTIMONIAL7_VIDEO from '@/assets/testimonial-video-7.mp4';
import NativePlayer from '@/components/VideoPlayer/NativePlayer.tsx';
import { ArrowLeft3, ArrowRight3 } from '@/components/Icons.tsx';

const Testimonials = () => (
  <section id="testimonials-section" className="bg-[#422933] pt-28 pb-14 md:pb-28 px-4 text-center">
    <h3 className="font-primary text-title md:text-heroTitle !font-extraBold">
      Testimonials
    </h3>
    <strong
      className="block font-primary font-medium text-body md:text-[1.125rem]
      text-[#D3B6AD] leading-[160%] tracking-[-0.18px] mt-4"
    >
      Here is what SATPrac COMPLETE members have to say about the site.
    </strong>

    <TestimonialsCarousel className="my-14 md:my-28" />
  </section>
);

export const TestimonialsCarousel = ({ className = '' }: { className?: string }) => (
  <Carousel items={TESTIMONIAL_VIDEOS} className={className} />
);

const Carousel = ({ items = [], className = '' }: { items?: string[]; className?: string }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);

  const isInView = useInView(videoRef);

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? items.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === items.length - 1 ? prev : prev + 1
    );
  };

  const leftDisabled = currentIndex === 0;
  const rightDisabled = currentIndex === items.length - 1;

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    if (isInView) videoElement.play();
    else videoElement.pause();
  }, [isInView]);

  return (
    <div
      className={`relative overflow-hidden mx-auto ${className}`}
      style={{ width: '100%', maxWidth: CAROUSEL_ITEM_WIDTH }}
    >
      <div className="overflow-hidden rounded-2xl shadow-lg">
        <NativePlayer
          ref={videoRef}
          src={items[currentIndex]}
          style={{
            width: '100%',
            maxWidth: CAROUSEL_ITEM_WIDTH,
            borderRadius: '24px',
            flexShrink: 0,
          }}
        />
      </div>

      <div className="flex justify-end gap-4 mt-4 mx-5">
        <button
          disabled={leftDisabled}
          className={`flex flex-shrink-0 justify-center items-center w-11 h-11 rounded-full bg-[#FEE7E1]
          ${leftDisabled ? 'opacity-50' : 'opacity-100'}`}
          onClick={prevSlide}
        >
          <ArrowLeft3 />
        </button>
        <button
          disabled={rightDisabled}
          className={`flex flex-shrink-0 justify-center items-center w-11 h-11 rounded-full bg-[#FEE7E1]
          ${rightDisabled ? 'opacity-50' : 'opacity-100'}`}
          onClick={nextSlide}
        >
          <ArrowRight3 />
        </button>
      </div>
    </div>
  );
};

const TESTIMONIAL_VIDEOS = [
  TESTIMONIAL0_VIDEO,
  TESTIMONIAL6_VIDEO,
  TESTIMONIAL7_VIDEO,
  TESTIMONIAL1_VIDEO,
  TESTIMONIAL3_VIDEO,
  TESTIMONIAL2_VIDEO,
  TESTIMONIAL4_VIDEO,
  TESTIMONIAL5_VIDEO,
];

const CAROUSEL_ITEM_WIDTH = 720;

export default Testimonials;
